module.exports = __webpack_public_path__ + "img/Copy of MILDRED TATE, PROFESSOR OF HOME ECONOMICS FROM 1937 THROUGH 1960.4474d5ca.jpg";